import api from './api';

const unwrap = async (request) => {
  const { data } = await request();
  return data;
};

export const getCommercialCatalog = async () => unwrap(() => api.get('/commercial-context/catalog'));
export const getCommercialResourceDependencies = async (resource, id) =>
  unwrap(() => api.get(`/commercial-context/${encodeURIComponent(resource)}/${id}/dependencies`));


export const listConfigurationProfiles = async () => unwrap(() => api.get('/commercial-context/list/configuration-profiles'));
export const saveConfigurationProfile = async (payload) => {
  const request = payload?.id
    ? () => api.put(`/commercial-context/configuration-profiles/${payload.id}`, payload)
    : () => api.post('/commercial-context/configuration-profiles', payload);
  const { data } = await request();
  return data;
};
export const deleteConfigurationProfile = async (id) => unwrap(() => api.delete(`/commercial-context/configuration-profiles/${id}`));
export const saveConfigurationProfileValues = async (id, values) => unwrap(() => api.put(`/commercial-context/configuration-profiles/${id}/values`, { values }));

export const listLegalEntities = async () => unwrap(() => api.get('/commercial-context/list/legal-entities'));
export const saveLegalEntity = async (payload) => {
  const request = payload?.id
    ? () => api.put(`/commercial-context/legal-entities/${payload.id}`, payload)
    : () => api.post('/commercial-context/legal-entities', payload);
  const { data } = await request();
  return data;
};
export const deleteLegalEntity = async (id) => unwrap(() => api.delete(`/commercial-context/legal-entities/${id}`));

export const listBrands = async () => unwrap(() => api.get('/commercial-context/list/brands'));
export const saveBrand = async (payload) => {
  const request = payload?.id
    ? () => api.put(`/commercial-context/brands/${payload.id}`, payload)
    : () => api.post('/commercial-context/brands', payload);
  const { data } = await request();
  return data;
};
export const deleteBrand = async (id) => unwrap(() => api.delete(`/commercial-context/brands/${id}`));

export const listBusinessUnits = async () => unwrap(() => api.get('/commercial-context/list/business-units'));
export const saveBusinessUnit = async (payload) => {
  const request = payload?.id
    ? () => api.put(`/commercial-context/business-units/${payload.id}`, payload)
    : () => api.post('/commercial-context/business-units', payload);
  const { data } = await request();
  return data;
};
export const deleteBusinessUnit = async (id) => unwrap(() => api.delete(`/commercial-context/business-units/${id}`));

export const listSalesChannels = async () => unwrap(() => api.get('/commercial-context/list/sales-channels'));
export const saveSalesChannel = async (payload) => {
  const request = payload?.id
    ? () => api.put(`/commercial-context/sales-channels/${payload.id}`, payload)
    : () => api.post('/commercial-context/sales-channels', payload);
  const { data } = await request();
  return data;
};
export const deleteSalesChannel = async (id) => unwrap(() => api.delete(`/commercial-context/sales-channels/${id}`));

export const listStorefronts = async () => unwrap(() => api.get('/commercial-context/list/storefronts'));
export const saveStorefront = async (payload) => {
  const request = payload?.id
    ? () => api.put(`/commercial-context/storefronts/${payload.id}`, payload)
    : () => api.post('/commercial-context/storefronts', payload);
  const { data } = await request();
  return data;
};
export const deleteStorefront = async (id) => unwrap(() => api.delete(`/commercial-context/storefronts/${id}`));
